import React, { useState, useEffect } from "react";
import ResReservation1 from "./resReservation1";
import ResReservation2 from "./resReservation2";
import ResReservation3 from "./resReservation3";
import MyResReservation from "./myReservation";
import SuccessReservationPage from "./successReservation";
import Loader from "../../UI/loader";
import SuccessFailScreen from "../../UI/SuccessFailScreen";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { getRestaurantReservationData } from "../../../action/resReservation";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { GetCustomerReservation } from "../../../action/resReservation";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { getResResStatus } from "../../../action/resReservation";
import { getResAllergies } from "../../../action/resReservation";
import { setRegPage } from "../../../action/action";
import { getPmsCustomerReservation } from "../../../action/resReservation";
import { updateRestaurantReservation } from "../../../action/resReservation";
import { createRestaurantReservation } from "../../../action/resReservation";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { CLICKED, EXIT } from "../../../config/constant";
import { sendAnalytics } from "../../../action/homeAction";


const ResReservation = (props) => {

    const { t } = props;
    const [data, setData] = useState(null);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const [statusName, setStatusName] = useState(null);
    const [currentPage, setCurrentPage] = useState(null);
    const [allergiesList , setAllergiesList] = useState(null);
    const [selectedResort, setSelectedResort] = useState(null);
    const [selectedRestaurant, setSelectedRestaurant] = useState(null);
    const [displayLoadingMsg , setDisplayLoadingMsg] = useState(false);
    const [reRenderMyReservation , setReRenderMyReservation] = useState(true);
    const [activeReservationList , setActiveReservationList] = useState([]);
    const [customerReservationData, setCustomerReservationData] = useState(null);
    const [internalPmReservationId , setInternalPmReservationId] = useState(null);
    const [customerExistingReservationData, setCustomerExistingReservationData] = useState(null);

    let widgetSesstionId = localStorage.getItem("resReservationSessionToken");
    let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
    let room = localStorage.getItem("room");

    const handleResortNext = (id) => {
        setSelectedResort(id);
        setCurrentPage(2);
    }

    const handleRestaurnatNext = (id) => {
        
        setSelectedRestaurant(id)
        setCurrentPage(3)
    }

    const handleRestaurantBooking = (data, updateData) => {
        
        setLoading(true)
        setDisplayLoadingMsg(updateData ? t('resReservation.updating_res') : t('resReservation.creating_res'))

        if(updateData){
            
            updateRestaurantReservation(data.createReservationBody)
            .then((res) => {
                setLoading(false)
                if(res.status == 200 && !res.data.Status){
                    setCustomerExistingReservationData(null);
                    setReRenderMyReservation(false);
                    fetchCustomerReservation();

                    if(selectedResort){
                        setCurrentPage(1);
                    } else {
                        setCurrentPage(2);
                    }

                    props.closeOrderPopUp(true, t('resReservation.success.thank_you'), t('resReservation.success.successful_res_update'),false);

                    props.sendAnalytics(
                        props.guestDetail, 
                        props.currentWidgets.widgetType, 
                        "UPDATE RESERVATION - SUCCESS", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId }, 
                        0, 
                        props.guestIsLoggedIn
                    );

                } else {
                    props.closeOrderPopUp(true, t('resReservation.errors.error_updating_reser'), "", true)

                    props.sendAnalytics(
                        props.guestDetail, 
                        props.currentWidgets.widgetType, 
                        "UPDATE RESERVATION - ERROR", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.data.Status, "errorMessage": JSON.stringify(res.data)  }, 
                        0, 
                        props.guestIsLoggedIn
                    );
                }
            })
            .catch((err) => { console.log(err); props.closeOrderPopUp(true, t('resReservation.errors.error_updating_reser'), "", true) })
        } else {

            createRestaurantReservation(data)
            .then((res) => {
                setLoading(false)
                if(res.status == 200 && !res.data.Status){
                    localStorage.setItem("resReservationCustomerId",res.data.reservation.reservationDetails[0].customerId)
                    setReRenderMyReservation(false);
                    fetchCustomerReservation();
                    setCurrentPage(4)

                    props.sendAnalytics(
                        props.guestDetail, 
                        props.currentWidgets.widgetType, 
                        "CREATE RESERVATION - SUCCESS", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId }, 
                        0, 
                        props.guestIsLoggedIn
                    );
                } else {
                    if(res.data.error.message.includes("There is already a reservation")){
                        props.closeOrderPopUp(true,t('resReservation.errors.error_existing_reser'), "", true)
                    } else {
                        props.closeOrderPopUp(true,t('resReservation.errors.error_creating_reser'), "", true)
                    }

                    props.sendAnalytics(
                        props.guestDetail, 
                        props.currentWidgets.widgetType, 
                        "CREATE RESERVATION - ERROR", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.data.Status, "errorMessage": JSON.stringify(res.data)  }, 
                        0, 
                        props.guestIsLoggedIn
                    );
                }
            })
        }
    }

    const handleDelete = (bool) => {
        setReRenderMyReservation(false);
        fetchCustomerReservation();

        if(bool){
            props.closeOrderPopUp(true,t('resReservation.success.successful_res_cancelled'), "", false)
        } else {
            props.closeOrderPopUp(true,t('resReservation.errors.error_cancelling_reser'), "", true)
        }
    } 


    const handleGoBack = () => {

        if (currentPage == 1) {
            props.setGoHome(true);
        }

        if (currentPage == 2) {
            if (data.length == 1) {
                props.setGoHome(true);
            } else {
                setCurrentPage(1);
            }
        }

        if (currentPage == 3) {
            setCustomerExistingReservationData(null);
            setCurrentPage(2)
        }
    }

    const handleEditReservation = (data) => {
        setSelectedResort(data.resortId);
        setSelectedRestaurant(data.restaurantId);
        setCustomerExistingReservationData(data)
        setCurrentPage(3);
    }

    const handleUserInfo = async () => {
        const currentUserInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))

        const userInfo = {
            reservationNumber: currentUserInfo[0].reservationNumber,
            plannedCheckOutDate: currentUserInfo[0].plannedCheckOutDate,
            firstName: currentUserInfo[0].guestProfile.firstName,
            lastName: currentUserInfo[0].guestProfile.lastName,
            customerId: localStorage.getItem("resReservationCustomerId"),
            email: currentUserInfo[0].guestProfile.email,
            phone: currentUserInfo[0].guestProfile.phone,
            address: currentUserInfo[0].guestProfile.addressLine1 + ", " + currentUserInfo[0].guestProfile.addressLine2 && (currentUserInfo[0].guestProfile.addressLine2 + " ,") + currentUserInfo[0].guestProfile.city + " ," + currentUserInfo[0].guestProfile.state + " ," + currentUserInfo[0].guestProfile.country
        }

        setUserInfo(userInfo);
    }

    const getDisplayStatusName = () => {
        getResResStatus()
            .then((res) => {
                if (res.status == 200) {
                    setStatusName(res.data.statuses)
                } else {
                    setStatusName([])

                    props.sendAnalytics(
                        props.guestDetail, 
                        props.currentWidgets.widgetType, 
                        "FETCH STATUS NAME - ERROR", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.data.Status, "errorMessage": JSON.stringify(res.data) }, 
                        0, 
                        props.guestIsLoggedIn
                    );
                }
            })
            .catch((err) => console.log("error while fetching status"))
    }

    const getResAllergiesList = () => {
        getResAllergies()
        .then((res) => {
            if (res.status == 200) {
                setAllergiesList(res.data.allergies)
            } else {
                setAllergiesList([])

                props.sendAnalytics(
                    props.guestDetail, 
                    props.currentWidgets.widgetType, 
                    "FETCH ALLERGIES LIST - ERROR", 
                    {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.data.Status, "errorMessage": JSON.stringify(res.data) }, 
                    0, 
                    props.guestIsLoggedIn
                );
            }
        })
        .catch((err) => console.log("error while fetching allergies"))
    }

    const fetchCustomerReservation = () => {

        if(!localStorage.getItem("resReservationCustomerId")){
            setLoading(false);
            setCurrentPage(1);
        } else {
        GetCustomerReservation()
            .then((res) => {
                setLoading(false);
                !currentPage && setCurrentPage(1);
                if (res.status == 200 && !res.data.Status) {
                    setCustomerReservationData(res.data.reservations)
                    setReRenderMyReservation(true);

                    res.data.reservations.forEach((reservation) => {
                        if(reservation.status == 1) { setActiveReservationList([...activeReservationList, reservation]) };
                    })

                    if(!localStorage.getItem("resReservationEmail")){
                        res.data.reservations && res.data.reservations.length > 0 && localStorage.setItem("resReservationEmail", res.data.reservations[res.data.reservations.length - 1].reservationDetails[0].email)
                    }

                } else {
                    setLoading(false);
                    setCurrentPage(1);
                    setTimeout(() => {
                        props.closeOrderPopUp(true,t('resReservation.errors.error_retrieve_reser'), "", true)
                    }, 1000);

                    props.sendAnalytics(
                        props.guestDetail, 
                        props.currentWidgets.widgetType, 
                        "FETCH CUSTOMER RESERVATION DETAILS - ERROR", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.data.Status, "errorMessage": JSON.stringify(res.data) }, 
                        0, 
                        props.guestIsLoggedIn
                    );
                }
            })
            .catch((err) => {
                console.log(err)
                setLoading(false);
                setCurrentPage(1);
                setTimeout(() => {
                    props.closeOrderPopUp(true,t('resReservation.errors.error_retrieve_reser'), "", true)
                }, 1000);
            })
        }
    }

    const fetchPmsCustomerReservation = () => {
        setLoading(true)
        getPmsCustomerReservation()
        .then((res) => {
            if (res.status == 200 && !res.data.Status) {
                setInternalPmReservationId(res.data.pmsCustomerReservation.internalReservationId);

                props.sendAnalytics(
                    props.guestDetail, 
                    props.currentWidgets.widgetType, 
                    "FETCH PMS CUSTOMER RESERVATION DETAILS - SUCCESS", 
                    {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId}, 
                    0, 
                    props.guestIsLoggedIn
                );
            } else {
                setErrorMsg(t('resReservation.errors.error_fetching_customer_details'));
                setLoading(false);
                setError(true);

                props.sendAnalytics(
                    props.guestDetail, 
                    props.currentWidgets.widgetType, 
                    "FETCH PMS CUSTOMER RESERVATION DETAILS - ERROR", 
                    {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.data.Status, "errorMessage": JSON.stringify(res.data) }, 
                    0, 
                    props.guestIsLoggedIn
                );
            }
        })
        .catch((err) => { setLoading(false); setError(true) })
    }

    const fetchResData = () => {

        setError(false);
        setLoading(true);

        getRestaurantReservationData()
            .then((res) => {
                if (res.status == 200) {
                    setData(res.data);
                    fetchCustomerReservation();

                    props.sendAnalytics(
                        props.guestDetail, 
                        props.currentWidgets.widgetType, 
                        "FETCH RESERVATION DATA - SUCCESS", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId}, 
                        0, 
                        props.guestIsLoggedIn
                    );
                } else {
                    setLoading(false);
                    setError(true)

                    props.sendAnalytics(
                        props.guestDetail, 
                        props.currentWidgets.widgetType, 
                        "FETCH RESERVATION DATA - ERROR", 
                        {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId, "errorStatus": res.data.Status, "errorMessage": JSON.stringify(res.data)}, 
                        0, 
                        props.guestIsLoggedIn
                    );
                }
            })
            .catch((err) => { setLoading(false); setError(true) })
    }

    const fetchData = async () => {
        if (room && room != "null") {
            fetchResData();
            handleUserInfo();
            fetchPmsCustomerReservation();
            getDisplayStatusName();
            getResAllergiesList();
        } else {
            if(process.env.REACT_APP_INROOMTAB == "true") {
                props.setLoginRequired(true)
            } else {
                props.setRegPage(true);
            }
        }
    };

    useEffect(() => {
        fetchData();

        props.sendAnalytics(
            props.guestDetail, 
            props.currentWidgets.widgetType, 
            CLICKED, 
            {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId}, 
            0, 
            props.guestIsLoggedIn
        );

        return () => {
            props.sendAnalytics(
                props.guestDetail, 
                props.currentWidgets.widgetType, 
                EXIT, 
                {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId}, 
                0, 
                props.guestIsLoggedIn
            );
        }
    }, [])

    return (
        <>
            {currentPage == 1 && <ResReservation1 data={data} next={(id) => handleResortNext(id)} goBack={() => handleGoBack()} />}
            {currentPage == 2 && <ResReservation2 data={data} next={(id) => handleRestaurnatNext(id)} goBack={() => handleGoBack()} selectedResortId={selectedResort} />}
            {currentPage == 3 && allergiesList && <ResReservation3 data={data} next={(data, updateData) => handleRestaurantBooking(data, updateData)} goBack={() => handleGoBack()} selectedResortId={selectedResort} selectedRestaurantId={selectedRestaurant} userInfo={userInfo} customerExistingReservationData={customerExistingReservationData} internalPmReservationId={internalPmReservationId} allergiesList={allergiesList} />}
            {(currentPage == 1 || currentPage == 2) && customerReservationData && reRenderMyReservation && statusName && <MyResReservation data={data} customerReservationData={customerReservationData} selectedResortId={selectedResort} displayStatusName={statusName} editReservation={(data) => handleEditReservation(data)} handleDelete={(bool) => handleDelete(bool)} />}
            {currentPage == 4 && <SuccessReservationPage goBack={() => setCurrentPage(2)} close={() => props.setGoHome(true)} />}
            {loading && <Loader displayMsg={displayLoadingMsg} />}
            {error && <SuccessFailScreen status={false} showTryAgain={true} showClose={true} statusMessage1={errorMsg || t('resReservation.errors.unable_process_request')} close={props.setGoHome} tryAgain={() => fetchData()} />}
        </>
    )
}


const mapStateToProps = state => {
    return {
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        currentWidgets: state.store.sideNavBar.currentWidget,
    }
}

export default connect(mapStateToProps, { setGoHome, closeOrderPopUp, setRegPage, setLoginRequired, sendAnalytics })(withTranslation('translations')(ResReservation));
